/*
	The changelog: recent builds and what changed, newest first. Static for now
	(no changelog endpoint on the boxart API yet) — when one lands, swap this for
	a fetch and keep the same shape.

	Single source of truth: the Changelog modal renders these builds, and the
	header's version chip derives its label from the newest one (see `latest`),
	so the button and the modal can never disagree.

	Each build: { version, date, additions?, changes?, fixes?, items: [...] }
*/

export var builds = [
	{
		version: '5',
		date: '29 June 2026',
		additions: 2,
		items: [
			'Added filtering of the archive list by your result and difficulty.',
			'Added a visualisation of the guess distribution to each archive day card.'
		]
	},
	{
		version: '4',
		date: '26 June 2026',
		additions: 1,
		items: [
			'Added an optional daily reminder, by email or geekmail, nudging you to play if you haven’t finished that day’s puzzle.'
		]
	},
	{
		version: '3',
		date: '25 June 2026',
		changes: 2,
		items: [
			'Re-designed the metrics on the archive day cards, with rings that fill to the solve and one-shot rates.',
			'Re-designed the leaderboard with clearer categories (Points, Streaks, One-Shots) and new sub-categories.'
		]
	},
	{
		version: '2',
		date: '24 June 2026',
		additions: 4,
		fixes: 2,
		items: [
			'Added the ability to sync recent guest guesses and practices when logged in.',
			'Added a user dashboard, shown when logged in, with your ranked and practice metrics.',
			'Added practice tracking for logged-in users.',
			'Added practice and ranked scores to archive day cards.',
			'Fixed archived days not showing your practice or live result.',
			'Fixed guessed game names falling back to the id if you refresh mid-guessing.'
		]
	},
	{
		version: '1',
		date: '22 June 2026',
		additions: 6,
		items: [
			'A new board game box art every day: 16 tiles, 16 guesses, hints unlocking as you go.',
			'Archive of past puzzles to practise, stepping through with previous / next.',
			'Leaderboards: daily score, solve streak, one-shot streak, and all-time points.',
			'Sign in with geekgroup or Google to keep your stats and streaks across devices.',
			'See how the community did: the tiles-to-solve distribution and solve rates per puzzle.',
			'Share your result as a spoiler-free grid.'
		]
	}
]

// the newest build's version, for the header chip — 'v1', 'v2', …
export var latest = builds.length ? builds[0].version : '1'

// the newest build (for recency / unread checks)
var newest = builds.length ? builds[0] : null

// where we remember the last changelog version the user opened
var SEEN_KEY = 'boxart.changelog.seen'

// how recent a build must be to nudge the user about it
var UNREAD_DAYS = 3

// parse a 'D Month YYYY' display date to a UTC ms timestamp (midnight that day),
// or null if it doesn't parse. Avoids relying on Date's locale string parsing.
function parseBuildDate(str) {

	var months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december']

	var parts = String(str || '').trim().toLowerCase().split(/\s+/)

	if (parts.length !== 3) return null

	var day = parseInt(parts[0], 10)
	var mon = months.indexOf(parts[1])
	var year = parseInt(parts[2], 10)

	if (isNaN(day) || mon < 0 || isNaN(year)) return null

	return Date.UTC(year, mon, day)

}

/*
	Whether there's an UNREAD changelog entry to nudge about: the newest build is
	within the last UNREAD_DAYS days AND hasn't been opened on this device (its
	version isn't the stored "seen" one). Drives the header dot + shake.
*/
export function unread() {

	if (!newest) return false

	var when = parseBuildDate(newest.date)

	if (when === null) return false

	// older than the window — no nudge
	if (when < Date.now() - UNREAD_DAYS * 86400000) return false

	try {

		return localStorage.getItem(SEEN_KEY) !== String(newest.version)

	} catch (e) {

		return true

	}

}

// remember that the user has opened the changelog at the newest version, so the
// dot + shake clear and don't return for this build
export function markSeen() {

	if (!newest) return

	try {

		localStorage.setItem(SEEN_KEY, String(newest.version))

	} catch (e) { /* storage disabled — the nudge simply persists, harmless */ }

}
